export default {
    bindings: {
        isAdmin: '<',
        canLoadStaff: '<',
        selectEvent: '&'
    },
    controller: 'displaySuggestionsController',
    template: require('../views/display.suggestions.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/checkout/components/display.suggestions.component.js